import Role from 'constants/role';
import { useHasRole } from 'hooks/useHasRole';
import React from 'react';
import { ReferenceField, TextField } from 'react-admin';
import VisibilityOffRounded from '@mui/icons-material/VisibilityOffRounded';
import { CopyField } from './CopyField';

function UserReferenceField(props) {
  const hasRole = useHasRole();
  if (!hasRole(Role.USER_VIEW)) {
    return <VisibilityOffRounded />;
  }
  return (
    <ReferenceField reference="users" {...props}>
      <div style={{ display: 'inline-flex', gap: 5 }}>
        <CopyField source="id" label="ID" />
        |
        <TextField source="information.firstName" emptyText="-" />
        <TextField source="information.lastName" emptyText="-" />
      </div>
    </ReferenceField>
  );
}
UserReferenceField.defaultProps = {
  label: 'User',
  source: 'userId',
};

export default UserReferenceField;
